import React from 'react';
import PropTypes from 'prop-types';
import Image from 'react-bootstrap/Image';
import Stack from 'react-bootstrap/Stack';
import Button from 'react-bootstrap/Button';
import { Trans } from 'react-i18next';
import FilterComponent from '../FilterComponent';
import SortUp from '../../assets/images/sort-up.svg';
import './index.scss';

const AssetClassHeader = ({ showSort }) => (
  <Stack direction="horizontal">
    <div className="ms-auto">
      <FilterComponent />
      {showSort && (
        <Button variant="outline-primary px-4">
          <Image src={SortUp} alt="Filter" className="pe-2" />
          <Trans>Sort</Trans>
        </Button>
      )}
    </div>
  </Stack>
);
AssetClassHeader.defaultProps = {
  showSort: false,
};
AssetClassHeader.propTypes = {
  showSort: PropTypes.bool,
};
export default AssetClassHeader;
